import * as React from "react";
import {css, cx} from "emotion";

import "./slider.scss";

import {cs}          from "@Common/react/chain-services";
import {GlobalEvent} from "@Common/react/global-event";
import {Static2}     from "@Common/react/static-2";
import {UseState}    from "@Common/react/use-state";
import {chain}       from "@Common/utils/fs";

import {OnGlobalKeyDownEscape} from "../../../../browser/global-key-down-escape";

// Value slider, not boolean toggle
export const Slider = (
    {
        state, background, translateDragging,
        getLabel=undefined, getLabelFrom=undefined, getLabelTo=undefined,
        xdQaNamePrefix=undefined,
    }
) => cs(
    ["dragging", (_, next) => UseState({next})],
    ["target", ({dragging}, next) => next(!dragging.value ? (
        state.value
    ) : (
        translateDragging(dragging.value)
    ))],
    ["addXdQaNamePrefix", (_, next) => next(xdQaNamePrefix == null ? (v=>v) : (v=>xdQaNamePrefix+ " " + v))],
    ({dragging, target, addXdQaNamePrefix}) => (
        <div className="slider-8ox">
            <div className="labels">
                <div className="from" xd-qa-type="label" xd-qa-name={addXdQaNamePrefix("Minimum")}>
                    {(getLabelFrom??getLabel)(target.from)}
                </div>
                <div className="to" xd-qa-type="label" xd-qa-name={addXdQaNamePrefix("Maximum")}>
                    {(getLabelTo??getLabel)(target.to)}
                </div>
            </div>
            <div className="line">
                {cs(
                    ["dom", (_, next) => Static2({next})],
                    ({dom}) => <>
                        <div
                            className={cx("line", css`
                                padding: 0 ${circle.r}px;
                            `)}
                        >
                            {dragging.value && <>
                                {GlobalEvent({
                                    eventName: "mousemove",
                                    fn: (e) => {
                                        const rect = dom.get().getBoundingClientRect();

                                        dragging.change((v) => v == null ? v : {
                                            ...v,
                                            value: chain(
                                                Math.max(e.clientX, rect.x),
                                                (_) => Math.min(_, rect.x + rect.width),
                                                (_) => (_ - rect.x) / rect.width,
                                                // (_) => translate(_ * (max - min) + min),
                                            ),
                                        });
                                    },
                                })}

                                {GlobalEvent({
                                    eventName: "mouseup",
                                    fn: () => {
                                        dragging.onChange(null);
                                        state.onChange(target);
                                    },
                                })}

                                {OnGlobalKeyDownEscape({
                                    action: () => dragging.onChange(null),
                                })}
                            </>}

                            <div className="inner" ref={dom.set}>
                                <div
                                    className="highlight"
                                    style={{
                                        left: (target.from * 100).toFixed(2) + "%",
                                        width: ((target.to - target.from) * 100).toFixed(2) + "%",
                                    }}
                                    xd-qa-type="style-filter"
                                    xd-qa-name={addXdQaNamePrefix("Range Bar")}
                                />

                                {Circle({
                                    pos: target.from,
                                    background,
                                    onMouseDown: () => dragging.onChange({
                                        value: state.value.from,
                                        oriValue: state.value.from,
                                        otherValue: state.value.to,
                                    }),
                                    xdQaName: addXdQaNamePrefix("Left Circle"),
                                })}
                                {Circle({
                                    pos: target.to,
                                    background,
                                    onMouseDown: () => dragging.onChange({
                                        value: state.value.to,
                                        oriValue: state.value.to,
                                        otherValue: state.value.from,
                                    }),
                                    xdQaName: addXdQaNamePrefix("Right Circle"),
                                })}
                            </div>
                        </div>
                    </>,
                )}
            </div>
        </div>
    ),
);

const circle = {
    r: 7,
    border: 3,
};

const Circle = ({pos, background, onMouseDown, xdQaName=undefined}) => (
    <div
        className={cx("circle-pos", css`
          --r: ${circle.r}px;
          --border-width: ${circle.border}px;
          --border-color: ${background};
        `)}
        style={{left: `${(pos * 100).toFixed(2)}%`}}
    >
        <div
            className="circle"
            draggable={false}
            onMouseDown={onMouseDown}
            xd-qa-type="icon"
            xd-qa-name={xdQaName}
        />
    </div>
);